import styled from '@emotion/styled';

import { FontFamily } from '@/enums/index';
import { IThemeProps } from '@/styles/themes/types';

export const TimezoneText = styled.div<IThemeProps>`
  font-family: ${({ theme }) => theme.legacy.typography.fontFamily[FontFamily.IBMPlexSans]};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.legacy.colors.lightText};
  text-transform: none;
  display: flex;
  align-items: center;
  flex-direction: row;
`;
